import React, { FunctionComponent } from 'react';
import { List, ListItem, Typography } from '@rbx/ui';
import { ResourcePath } from '@modules/openCloud/utils/getEndpointResourcePathOptions';
import { useTranslation } from '@rbx/intl';

import { HttpMethods } from '@modules/openCloud/utils/oasTypes';
import { resourcePathsSelectListID } from '@modules/openCloud/page/main/constants/openCloudConstants';
import ResourcePathItem from './ResourcePathItem';
import useResourcePathSelectListStyles from './ResourcePathSelectList.styles';

export interface ResourcePathSelectListProps {
  selectedResourcePathName: string;
  resourcePaths: ResourcePath[];
  method: HttpMethods;
  onSelect: (targetResourcePath: ResourcePath) => void;
}

const ResourcePathSelectList: FunctionComponent<
  React.PropsWithChildren<ResourcePathSelectListProps>
> = ({ selectedResourcePathName, resourcePaths, method, onSelect }) => {
  const { translate } = useTranslation();

  const {
    classes: { list, listHeader, listItem, maxWidth100 },
  } = useResourcePathSelectListStyles();

  return (
    <List id={resourcePathsSelectListID} className={list}>
      <ListItem className={listHeader}>
        <Typography className={maxWidth100} variant='largeLabel1' color='secondary'>
          {translate('Label.ResourcePaths')}
        </Typography>
      </ListItem>
      {resourcePaths.map((resourcePath) => (
        <ListItem
          key={resourcePath.name}
          onClick={() => {
            onSelect(resourcePath);
          }}
          className={listItem}>
          <ResourcePathItem
            active={resourcePath.name === selectedResourcePathName}
            method={method}
            resourcePathName={resourcePath.name}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default ResourcePathSelectList;
